import { EntitySelector } from "@/components/EntitySelector";
import { useIntegrationConnection } from "@/hooks/useIntegrationConnection";
import { useParams } from "react-router-dom";

export function EntitySelectorTestPage() {
  const { integration } = useParams<{ integration: string }>();
  const connection = useIntegrationConnection(integration!);

  if (!connection) {
    return <div>No connector found</div>;
  }

  return (
    <div className="flex flex-row gap-10">
      <EntitySelector
        connection={connection}
        onSelect={console.log}
        onClose={console.log}
        className="w-[700px] h-[500px] border rounded-lg"
      />

      <EntitySelector
        connection={connection}
        onSelect={console.log}
        onClose={console.log}
        className="w-[400px] h-[900px] border rounded-lg"
      />
    </div>
  );
}
